const EntryStatusInquiry = () => import('../pages/online_collection/EntryStatusInquiry.vue');
const BankReconciliations = () => import('../pages/online_collection/BankReconciliations.vue');
// const BusinessReconciliation = () => import('../pages/online_collection/BusinessReconciliation.vue');
const MerchantNumManag = () => import('../pages/online_collection/MerchantNumManag.vue');
// const BlankPage = () => import('../pages/online_collection/BlankPage.vue');
const OrderTracking = () => import('../pages/online_collection/OrderTracking.vue');

export default [{
	// 入账状态查询
	path: '/EntryStatusInquiry',
	name: 'EntryStatusInquiry',
	component: EntryStatusInquiry,
},
{
	// 银行对账
	path: '/BankReconciliations',
	name: 'BankReconciliations',
	component: BankReconciliations,
},
	// {
	//   // 业务对账
	//   path: '/BusinessReconciliation',
	//   name: 'BusinessReconciliation',
	//   component: BusinessReconciliation
	// },
{
	// 商户号管理
	path: '/MerchantNumManag',
	name: 'MerchantNumManag',
	component: MerchantNumManag,
},
{
	// 订单查询
	path: '/OrderTracking',
	name: 'OrderTracking',
	component: OrderTracking,
},
{
	path: '/IncomingSummary',
	name: 'IncomingSummary',
	component: () => import('../pages/online_collection/IncomingSummary'),
},
{
	path: '/TreeDemo',
	name: 'TreeDemo',
	component: () => import('../pages/online_collection/TreeDemo'),
},
];
